import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import HomeView from "./views/HomeView";
import SolarSystemView from "./views/SolarSystemView";
import TelescopeView from "./views/TelescopeView";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <HomeView />
        </Route>

        <Route path="/solar-system">
          <SolarSystemView />
        </Route>

        <Route path="/telescope">
          <TelescopeView />
        </Route>

        <Route exact path="/#model-viewer-no-ar-fallback">
          <Redirect to="/telescope" />
        </Route>

        <Route exact path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
